import {ChangeEvent} from 'react';
import FormikLikeInput from '../../../../../components/formikFileds/likeInput';

interface LinkDescriptionSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const LinkDescriptionSection = ({
  value,
  onChange,
}: LinkDescriptionSectionProps) => (
  <section className="mt-4">
    <p className="mb-2 color-gray-1 text-md font-medium">
      عنوان پیوست <span className="text-red-600">*</span>
    </p>
    <span className="flex text-xs text-gray-900 mb-2">
      برای پیوست یک عنوان انتخاب کنید.
    </span>
    <FormikLikeInput
      name="link_description"
      label="عنوان آگهی"
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    />
  </section>
);

export default LinkDescriptionSection;
